<template>
  <ul id="topMenuUl" class="clearfloat">
    <li
      v-for="(item, index) in $store.state.topMenuList"
      :key="index"
      :class="{ active: nowPath == item.link }"
      :style="{ width }"
      class="clearfloat"
    >
      <p @click="clickMenu(item, index)" :title="item.name">
        {{ item.name }}
      </p>
      <Icon
        v-show="item.id != 0"
        type="md-close"
        @click="delMenu(item, index)"
      />
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      width: 20 + "%",
      nowPath: this.$route.path,
      keepAlivePage: [],
    };
  },
  methods: {
    setWidth() {
      this.width = 100 / this.$store.state.topMenuList.length + "%";
    },
    delMenu(row, index) {
      this.$route.meta.keepAlive = false; //删除缓存页面

      if (this.$store.state.topMenuList.length > 1) {
        this.$store.state.topMenuList.splice(index, 1);

        if (row.link == this.nowPath) {
          if (index == this.$store.state.topMenuList.length) {
            this.clickMenu(this.$store.state.topMenuList[index - 1], index - 1);
          } else {
            this.clickMenu(this.$store.state.topMenuList[index], index);
          }
        }
      }
    },
    clickMenu(row, index) {
      this.$router.push({
        path: row.link,
        query: { now: row.now },
      });
    },
    nowActive() {
      var ddd = this.$store.state.topMenuList;
      for (const i in ddd) {
        if (ddd[i].link == this.nowPath) {
          this.$store.state.nowActiveTitle = ddd[i].name;
        }
      }
    },
  },
  computed: {
    watchTopMenuList() {
      return this.$store.state.topMenuList;
    },
  },
  watch: {
    $route(to, from) {
      setTimeout(() => {
        this.nowActive();
      }, 400);

      this.nowPath = to.path;
      if (to.meta.keepAlive) {
        if (this.keepAlivePage.indexOf(to.path) == -1) {
          this.keepAlivePage.push(to.path);
          if (this.keepAlivePage.length > 10) {
            location.reload();
          }
        }
      }
    },
    watchTopMenuList(v) {
      this.setWidth();
      if (v.length > 50) {
        this.$Modal.confirm({
          title: "页面打开过多，建议刷新一下",
          content: "标签过多会降低平台运行速率",
          okText: "立即刷新",
          cancelText: "暂不刷新",
          onOk: () => {
            location.reload();
          },
        });
      }
    },
  },
};
</script>
<style>
#topMenuUl {
  width: 100%;
  height: 100%;
  display: flex;
}

#topMenuUl li {
  color: #999;
  line-height: 50px;
  max-width: 6em;
  min-width: 20px;
  position: relative;
}
#topMenuUl li p {
  float: left;
  overflow: hidden;
  width: 85%;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--fontColor);
}
#topMenuUl li:nth-child(1) p {
  width: 95%;
}
#topMenuUl li:hover,
#topMenuUl li.active,
#topMenuUl li.active p {
  color: var(--fontColor);
  font-weight: bold;
  cursor: pointer;
}
#topMenuUl li i {
  font-size: 14px;
  position: absolute;
  right: 0;
  top: 18px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/sys/topMenu.vue